import { useState, useEffect } from 'react';
import { theme } from '../../theme';

export default function PwaInstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Already running as installed PWA — no need to show banner
    const isPwa = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isPwa) return;

    // Recently dismissed — respect 7-day cooldown
    const dismissed = localStorage.getItem('pwa-dismiss');
    if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowBanner(false);
    if (outcome === 'accepted') {
      localStorage.setItem('pwa-dismiss', String(Date.now()));
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-dismiss', String(Date.now()));
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 64,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '0 12px',
    }}>
      <div style={{
        maxWidth: 480,
        width: '100%',
        background: `linear-gradient(135deg, ${theme.card}, ${theme.surface})`,
        border: `1px solid ${theme.accent}33`,
        borderRadius: 16,
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: `0 4px 20px ${theme.accent}22`,
      }}>
        <span style={{ fontSize: 24 }}>📱</span>
        <div style={{ flex: 1 }}>
          <div style={{ color: theme.text, fontSize: 14, fontWeight: 600 }}>
            Bæta Greiði á heimaskjá
          </div>
          <div style={{ color: theme.textMuted, fontSize: 12 }}>
            Fáðu aðgang hraðar
          </div>
        </div>
        <button
          onClick={handleInstall}
          style={{
            background: theme.accent,
            color: '#000',
            border: 'none',
            borderRadius: 8,
            padding: '8px 14px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            minHeight: 44,
          }}
        >
          Setja upp
        </button>
        <button
          onClick={handleDismiss}
          aria-label="Loka"
          style={{
            background: 'none',
            border: 'none',
            color: theme.textMuted,
            fontSize: 18,
            cursor: 'pointer',
            padding: 4,
            minHeight: 44,
            minWidth: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
